import { render, staticRenderFns } from "./DetectionRequestFilter.vue?vue&type=template&id=fdbd282c&scoped=true"
import script from "./DetectionRequestFilter.vue?vue&type=script&lang=js"
export * from "./DetectionRequestFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbd282c",
  null
  
)

export default component.exports